<template>
    <div>
        <el-dialog :visible.sync="visible"
            :title="$t('retailInstance.text.batchDelete')"
            :close-on-click-modal="false"
            :before-close="handleClose" class="bind-dialog  create-host">
            <div class="tip-warning mb20" style="line-height: 19px"
                v-html="$t('privateNetInstance.batchDeleteTips')">
            </div>
            <batch-instance-table v-bind="$attrs" :multipleSelection="multipleSelection">
            </batch-instance-table>
            <div style="margin-top: 30px; margin-left: 100px">
                <input type="checkbox" v-model="sureDelete" id="sureCharge"/>
                <label for="sureCharge">{{ $t('retailInstance.tooltip.knowAboutFee') }}</label>
            </div>
            <div slot="footer">
                <el-button @click="cancelBind">
                    {{ $t('privateNetInstance.cancel') }}
                </el-button>
                <el-button @click="sureBind" :disabled="!sureDelete"
                    type="primary">
                    {{ $t('privateNetInstance.bindSure') }}
                </el-button>
            </div>
        </el-dialog>
        <jcb-opt-protect 
            :visible.sync="operationProtectVisible" 
            :action-type="OperationConstant.BATCH_DELETE"
            @success="onSuccess" @error="onError">
        </jcb-opt-protect>
    </div>
</template>

<script>
import BatchInstanceTable from '@/components/common/BatchInstanceTable';
import operationProtect from '@/mixins/operationProject';
import { OperationConstant } from '@/common/Constants';
export default {
	name: 'BatchDelete',
    mixins: [operationProtect],
    components: {
        BatchInstanceTable
    },
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		multipleSelection: {
			type: Array,
			default: []
		},
		region: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
            sureDelete: false,
            operationProtectVisible: false,
		};
	},
    computed: {
		OperationConstant: () => OperationConstant
	},
	methods: {
		handleClose() {
			this.$emit('update:visible', false);
            this.sureDelete = false;
		},
		cancelBind() {
			this.handleClose();
		},
        sureBind() {
            this.openOperationProtect(OperationConstant.BATCH_DELETE, this.multipleSelection, this.region);
			this.handleClose();
        },
		deleteBatch(headers) {
			let sourceHeaders={'Content-Type': 'application/json'};
			let instanceIds = this.multipleSelection.map(item => item.instanceId)
			const params = {
				region: this.region,
				clientToken: Normal.getClientToken(),
				instanceIds
			};

			Ajax.put('/api/cps/removeInstances', params,{
				headers: Object.assign({}, headers, sourceHeaders)
			})
			.then((res) => {
				this.$message.success(this.$t('privateNetInstance.operateSuccess'));
			})
			.catch(async (err) => {
				const { response } = err.data;
				try {
					const json = await response.json();
					this.$message.error(json.errmsg);
				} catch (ex) {
					console.log(ex);
				}
			})
			.finally(() => {
				this.$emit('refresh');
			});
		},
	}
};
</script>

<style lang="scss">
	.bind-dialog {
		.chooseInfo {
			margin-bottom: 5px;
			font-size: 12px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/common/BatchDelete.vue